<template>
  <div id="app">
    <!-- Navigation Bar -->
    <NavBar />

    <!-- Main Content -->
    <router-view />
  </div>
</template>

<script>
import { watch } from 'vue'
import NavBar from './views/components/layout/NavBar.vue'
import { useFirebaseAuth } from '@/composables/useFirebaseAuth'
import { useCommunityPreload } from '@/composables/useCommunityPreload'

export default {
  name: 'App',
  components: {
    NavBar,
  },
  setup() {
    const { isAuthenticated, initAuth } = useFirebaseAuth()
    const { preloadCommunityData, isLoaded } = useCommunityPreload()

    // Initialize auth
    initAuth()

    // Watch for authentication status and preload community data
    watch(isAuthenticated, (authenticated) => {
      if (authenticated && !isLoaded.value) {
        console.log('[App] User authenticated, triggering community data preload...')
        // Use setTimeout to ensure it runs in background without blocking UI
        setTimeout(() => {
          preloadCommunityData()
        }, 1000) // Wait 1 second after login to let other components load first
      }
    }, { immediate: true })

    return {
      isAuthenticated
    }
  }
}
</script>

<style>
/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  background-color: #f8f9fa;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Global Modal Centering Styles */
.modal-dialog {
  display: flex;
  align-items: center;
  min-height: calc(100vh - 1rem);
  margin: 0.5rem auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100vh - 1rem);
}

@media (min-width: 576px) {
  .modal-dialog {
    min-height: calc(100vh - 3.5rem);
    margin: 1.75rem auto;
  }

  .modal-dialog-centered {
    min-height: calc(100vh - 3.5rem);
  }
}

/* Ensure modal content is scrollable when too tall */
.modal-dialog-scrollable {
  max-height: calc(100vh - 1rem);
}

@media (min-width: 576px) {
  .modal-dialog-scrollable {
    max-height: calc(100vh - 3.5rem);
  }
}

.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 3.5rem);
  overflow: hidden;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

</style>
